var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input input--quantity", attrs: { "upsell-qty": "" } },
    [
      !_vm.$attrs.readonly
        ? _c(
            "VButton",
            {
              staticClass: "input__quantity-btn input__quantity-btn--decrement",
              attrs: { label: "Decrement Quantity", "hide-label": true },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.quantity - _vm.step < 0 ? 0 : (_vm.quantity -= _vm.step)
                }
              }
            },
            [
              _c("Icon", {
                attrs: {
                  name: _vm.iconDecrement,
                  size: "10px",
                  fill: "transparent",
                  stroke: "currentColor"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "label",
        {
          class: _vm.labelClass,
          attrs: { for: "quantity-input__" + _vm._uid }
        },
        [_vm._v(_vm._s(_vm.label))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.quantity,
            expression: "quantity"
          }
        ],
        staticStyle: { "pointer-events": "none" },
        attrs: {
          id: "quantity-input__" + _vm._uid,
          name: "quantity",
          type: "number",
          min: _vm.min,
          max: _vm.max,
          readonly: _vm.$attrs.readonly
        },
        domProps: { value: _vm.quantity },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.quantity = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      !_vm.$attrs.readonly
        ? _c(
            "VButton",
            {
              staticClass: "input__quantity-btn input__quantity-btn--increment",
              attrs: {
                label: "Increment Quantity",
                "hide-label": true,
                disabled: _vm.disableIncrement
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.quantity += _vm.step
                }
              }
            },
            [
              _c("Icon", {
                attrs: {
                  name: _vm.iconIncrement,
                  size: "10px",
                  fill: "currentColor"
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }